import { useQuery } from '@tanstack/react-query';
import useApi from 'hooks/useApi';
import marketPlaceFactory from 'utils/factories/marketplace';

const useUserBankAccount = () => {
  const apiClient = useApi();

  return useQuery({
    queryKey: marketPlaceFactory.bankAccount(),
    queryFn: async () => apiClient.payments.apiPaymentsbankAccountGet(),
    select: (data) => data?.data,
  });
};

export default useUserBankAccount;
